import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIncorrectIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 19,
	viewBox: "0 0 20 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.0625 4.4375L4.9375 14.5625",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.0625 14.5625L4.9375 4.4375",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})] })
});
export default SvgIncorrectIcon;
